import React, {ReactNode} from 'react';
import {Box, Button, Skeleton} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {useProjectData} from "../../hooks/useProjectData";
import PageHeader from "./PageHeader";

interface ProjectHeaderProps {
    showFab?: boolean
    replaceFab?: ReactNode
    pageTitle: string
    nextToTitle?: ReactNode
    overline?: string
    children?: ReactNode | string
    onFabClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

function ProjectPageHeader({
                               pageTitle,
                               nextToTitle,
                               overline,
                               children,
                               showFab,
                               onFabClick,
                               replaceFab,
                           }: ProjectHeaderProps) {
    const {project} = useProjectData()

    if (!project) {
        return (
            <Box>
                <Skeleton height={60} width={220}/>
            </Box>
        )
    }

    const actionButton = (
        <Button variant="contained" startIcon={<AddIcon/>} onClick={onFabClick}>
            Create
        </Button>
    )

    return (
        <PageHeader pageTitle={pageTitle}
                    nextToTitle={nextToTitle}
                    overline={overline}
                    fab={replaceFab || (showFab && actionButton)}
        >
            {children}
        </PageHeader>
    )
}


export default ProjectPageHeader;
